import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ConfigurationService} from '../../configuration.service';
import {UrlEndpoints} from '../../../definitions/url-endpoints';

@Injectable({
    providedIn: 'root'
})
export class PlantHireResourceService {

    constructor(private http: HttpClient,
                private configuration: ConfigurationService,
                private urlEndpoints: UrlEndpoints) {
    }

    getHireDeptList() {
        return this.http.get(this.configuration.buildUrl(this.urlEndpoints.hireDeptListEndPoint)).toPromise();
    }

    getHireGroupList() {
        return this.http.get(this.configuration.buildUrl(this.urlEndpoints.hireDeptGroupListEndPoint)).toPromise();
    }

    getEquipment() {
        return this.http.get(this.configuration.buildUrl(this.urlEndpoints.equipmentListByTstampEndPoint
            + this.configuration.getConfiguration().equipmentDateTime)).toPromise();
    }

    getPlantStatus() {
        return this.http.get(this.configuration.buildUrl(this.urlEndpoints.plantStatusListEndPoint)).toPromise();
    }

    getHaccess() {
        return this.http.get(this.configuration.buildUrl(this.urlEndpoints.haccessListByTstampEndPoint
            + this.configuration.getConfiguration().equipmentDateTime)).toPromise();
    }

    getHrates() {
        return this.http.get(this.configuration.buildUrl(this.urlEndpoints.hRatesEndpoint)).toPromise();
    }
}
